import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const startCreditPackageChargingProcess = async (selectedDomain: string, packageId: number, isDirect: boolean = false): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `billing/credits`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        params: {
            packageId,
            isDirect
        },
        isEncrypted: true,
    });
}